import React, { useState, useRef } from "react";
import DropdownPortal from "./DropdownPortal"; // ajuste o caminho conforme necessário

interface DropdownSelectorProps {
  currentText: string;
  items: { id: number; label: string }[];
  onSelect: (selectedLabel: string) => void;
  buttonClassName?: string;
  buttonStyle?: React.CSSProperties;
}

const ITEM_HEIGHT = 40; // altura aproximada de cada item (ajuste se necessário)
const VERTICAL_PADDING = 8; // padding extra no menu (acima+abaixo)

const DropdownSelector: React.FC<DropdownSelectorProps> = ({
  currentText,
  items,
  onSelect,
  buttonClassName,
  buttonStyle,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [portalPosition, setPortalPosition] = useState({ x: 0, y: 0 });
  const buttonRef = useRef<HTMLButtonElement>(null);

  const openPortal = () => {
    if (!buttonRef.current) return;

    const rect = buttonRef.current.getBoundingClientRect();
    const estimatedMenuHeight = items.length * ITEM_HEIGHT + VERTICAL_PADDING;
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    let y: number;
    if (spaceBelow < estimatedMenuHeight && spaceAbove > estimatedMenuHeight) {
      // abre para cima
      y = rect.top - estimatedMenuHeight;
    } else {
      // abre para baixo
      y = rect.bottom;
    }

    setPortalPosition({ x: rect.left, y });
    setIsOpen(true);
  };

  const closePortal = () => setIsOpen(false);

  return (
    <div className="d-flex align-items-center" style={{ position: "relative" }}>
      <button
        ref={buttonRef}
        onClick={e => {
          e.stopPropagation();
          openPortal();
        }}
        className={buttonClassName || "badge"}
        style={{ border: "none", cursor: "pointer", ...buttonStyle }}
      >
        {currentText}
      </button>

      <DropdownPortal isOpen={isOpen} onClose={closePortal} position={portalPosition}>
        <div
          style={{
            background: "white",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            borderRadius: 4,
            padding: "4px 0",
            maxHeight: 300,
            overflowY: "auto",
          }}
        >
          {items.map(item => (
            <button
              key={item.id}
              className="dropdown-item"
              onClick={() => {
                onSelect(item.label);
                closePortal();
              }}
              style={{
                display: "block",
                width: "100%",
                textAlign: "left",
                padding: "0.5rem 1rem",
                background: "none",
                border: "none",
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      </DropdownPortal>
    </div>
  );
};

export default DropdownSelector;
